import React, { useState } from 'react'
import HotelDetails from '../components/HotelDetails';
import HotelEnterYourDetails from '../components/HotelEnterYourDetails';
import HotelPayment from '../components/HotelPayment';
import { useTranslation } from "react-i18next";

const MyBooking = () => {
  const [current, setCurrent] = useState(0);
    const { t } = useTranslation();

  return (
    <section className="steps-form-sec position-relative z-1 pt-5 pb-5">
      <div className="container">
        <div className="inner-form-sec">
          <form id="msform">
            {/* Progressbar */}
            <ul id="progressbar">
              <li className={current >= 0 ? "active" : ""}></li>
              <li className={current >= 1 ? "active" : ""}></li>
              <li className={current >= 2 ? "active" : ""}></li>
            </ul>
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: `${((current + 1) / 3) * 100}%` }}
              ></div>
            </div>

            {/* Step 1 */}
            {current === 0 && (
              <div className="stups-form-sec hotel-form-step">
                <div className="stups-form-box">
                  <div className="trip-box-details">
                    <div className='row'>
                      <div class="col-lg-5 col-md-12 mb-4">
                          <HotelDetails />
                       </div>
                       <div className='col-lg-7 col-md-12 mb-4'>
                          <HotelEnterYourDetails />
                       </div>
                    </div>
                  </div>
                    <div className="row">
                      <div className="col-lg-5 col-md-12">
                        <div className="btn-box-com-bottom d-flex justify-content-end mt-4 gap-2">
                          <button type="button" className="next btn btn-primary" onClick={() => setCurrent(1)}> {t("next")} </button>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            )}

            {/* Step 2 */}
            {current === 1 && (
              <div className="stups-form-sec">
                <div className="stups-form-box">
                  <div className="trip-box-details">
                    <div className='row'>
                      <div class="col-lg-5 col-md-12 mb-4">
                          <HotelDetails />
                       </div>
                       <div className='col-lg-7 col-md-12 mb-4'>
                          <HotelPayment />
                       </div>
                    </div>
                  </div>
                    <div className="row">
                      <div className="col-lg-5 col-md-12">
                        <div className="btn-box-com-bottom d-flex justify-content-between mt-4 gap-2">
                          <button type="button" className="previous d-flex align-items-center gap-2 bg-transparent p-0 m-0 border-0 btn-text-blue" onClick={() => setCurrent(0)}>{t("back")}</button>
                          <button type="button" className="next btn btn-primary" onClick={() => setCurrent(2)}> {t("next")} </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Step 3 */}
            {current === 2 && (
              <div className="stups-form-sec">
                <h2 className='m-0'>{t("finish_title")}</h2>
                <p>{t("finish_message")}</p>

                  <div className="row">
                    <div className="col-lg-5 col-md-12">
                      <div className="btn-box-com-bottom d-flex justify-content-between mt-4 gap-2">
                        <button type="button" className="previous d-flex align-items-center gap-2 bg-transparent p-0 m-0 border-0 btn-text-blue" onClick={() => setCurrent(1)} > {t("back")} </button>
                        <button type="submit" className="btn btn-primary"> {t("submit")} </button>
                      </div>
                    </div>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  )
}

export default MyBooking